import type { SpeechProviderId } from './types';

/**
 * Module-scoped registry of the single active speech session, regardless of which
 * provider started it. `MessageInput`/`WelcomeScreen` remount on every welcome→chat
 * transition and on `sendError`/`messagesError` early returns (see CLAUDE.md's
 * silent-failure pattern 3) — a `useRef` guard would not survive that remount and
 * a `MediaStream` (or an open recognition session) would keep running with no
 * error. Living at module scope, this registry survives the remount instead.
 */

interface ActiveSpeechSession {
  providerId: SpeechProviderId;
  stop: () => Promise<void>;
}

let activeSession: ActiveSpeechSession | null = null;

export function registerActiveSpeechSession(session: ActiveSpeechSession): void {
  activeSession = session;
}

/** No-op if `session` is no longer the registered one (already replaced or cleared). */
export function clearActiveSpeechSession(session: ActiveSpeechSession): void {
  if (activeSession === session) {
    activeSession = null;
  }
}

export async function stopActiveSpeechSession(): Promise<void> {
  const session = activeSession;
  if (!session) return;
  activeSession = null;
  await session.stop();
}
